"use client";

import { useContext } from "react";
import { OrganizationContext } from "@/app/providers/OrganizationProvider";

/**
 * Hook to access the organization context.
 * Must be used within an OrganizationProvider.
 * @returns The organization context
 * @throws Error if used outside of OrganizationProvider
 */
export function useOrganization() {
  const context = useContext(OrganizationContext);
  if (!context) {
    throw new Error("useOrganization must be used within an OrganizationProvider");
  }
  return context;
}